import { useCallback } from "react"
import useAgendaAppointments from "./useAgendaAppointments"
import useAgendaPatientQuickActions from "./useAgendaPatientQuickActions"
import useAgendaFinance from "./useAgendaFinance"
import useAgendaClinicalActions from "./useAgendaClinicalActions"
import useAgendaDragAndDrop from "./useAgendaDragAndDrop"

export default function useAgendaActions(props) {
  const {
    API_BASE,
    clinicId,
    date,
    selectedAppointment,
    loadAgenda,
    isReadOnly,
    readOnlyReason,
    setSelectedAppointment,
  } = props

  const appointments = useAgendaAppointments(props)
  const patientQuick = useAgendaPatientQuickActions(props)
  const finance = useAgendaFinance(props)
  const clinical = useAgendaClinicalActions(props)
  const drag = useAgendaDragAndDrop(props)

  const updateSelectedAppointmentColor = useCallback(
    async (customTagColor) => {
      if (isReadOnly) {
        alert(readOnlyReason || "Modo solo lectura activo")
        return false
      }

      if (!selectedAppointment?.id) {
        alert("No hay cita seleccionada")
        return false
      }

      try {
        const token = localStorage.getItem("odontoflow_token") || ""

        const headers = {
          "Content-Type": "application/json",
        }

        if (token) {
          headers.Authorization = `Bearer ${token}`
        }

        if (clinicId && clinicId !== "ALL") {
          headers["x-clinic-id"] = clinicId
        }

        const response = await fetch(`${API_BASE}/appointments/update-visual-tag`, {
          method: "PATCH",
          headers,
          body: JSON.stringify({
            appointmentId: selectedAppointment.id,
            clinicId,
            customTagColor: customTagColor || null,
          }),
        })

        const data = await response.json().catch(() => null)

        if (!response.ok) {
          alert(data?.message || "No se pudo actualizar la marca visual")
          return false
        }

        if (typeof setSelectedAppointment === "function") {
          setSelectedAppointment((prev) =>
            prev
              ? {
                  ...prev,
                  customTagColor: customTagColor || null,
                }
              : prev,
          )
        }

        if (typeof loadAgenda === "function") {
          await loadAgenda(clinicId, date)
        }

        return true
      } catch {
        alert("Error al actualizar la marca visual")
        return false
      }
    },
    [
      API_BASE,
      clinicId,
      date,
      selectedAppointment,
      loadAgenda,
      isReadOnly,
      readOnlyReason,
      setSelectedAppointment,
    ],
  )

  return {
    ...appointments,
    ...patientQuick,
    ...finance,
    ...clinical,
    ...drag,
    updateSelectedAppointmentColor,
  }
}